// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 167 ? "80289b8c" : chunkId) + "." + {"167":"a43e17b4070980a6","580":"6856ebd3ea6a84e4","735":"9359b209896f9138"}[chunkId] + ".js";
};